import moment from 'moment';
import * as React from 'react';

import {
  Container,
  HeaderRow,
  HeaderLabel,
  PercentLabel,
  Row,
  DateLabel,
  BarContainer,
  Bar,
} from './BreakdownChart.styles';

type Data = {
  startDate: string;
  endDate: string;
  leftValue: number;
  rightValue: number;
};

interface IBreakdownChartProps {
  id: string;
  leftLabel: string;
  rightLabel: string;
  startPeriod: Data;
  endPeriod: Data;
  onHover: (h: any) => void;
}

const CURRENT_YEAR_COLORS = ['#FF600F', 'rgba(255, 96, 15, 0.3)'];
const PREVIOUS_YEAR_COLORS = ['#ADAFB2', '#E6E6E6'];

const getPeriiodString = (period: { startDate: string; endDate: string }) =>
  `${moment(period.startDate).format('MMM YY')} - ${moment(
    period.endDate
  ).format('MMM YY')}`;

const getRelativePercentage = (mainValue: number, comparingValue: number) =>
  mainValue === 0 && comparingValue === 0
    ? '-'
    : `${Math.round((mainValue / (mainValue + comparingValue)) * 100)}%`;

export const BreakdownChart: React.FC<IBreakdownChartProps> = ({
  id,
  leftLabel,
  rightLabel,
  startPeriod,
  endPeriod,
  onHover = () => {},
}) => {
  const startLeftPercentage = getRelativePercentage(
    startPeriod.leftValue,
    startPeriod.rightValue
  );
  const startRightPercentage = getRelativePercentage(
    startPeriod.rightValue,
    startPeriod.leftValue
  );
  const endLeftPercentage = getRelativePercentage(
    endPeriod.leftValue,
    endPeriod.rightValue
  );
  const endRightPercentage = getRelativePercentage(
    endPeriod.rightValue,
    endPeriod.leftValue
  );
  return (
    <Container id={id}>
      <HeaderRow>
        <HeaderLabel>{leftLabel}</HeaderLabel>
        <HeaderLabel>{rightLabel}</HeaderLabel>
      </HeaderRow>
      <HeaderRow>
        <PercentLabel>{startLeftPercentage}</PercentLabel>
        <PercentLabel>{startRightPercentage}</PercentLabel>
      </HeaderRow>
      <Row>
        <DateLabel>{getPeriiodString(startPeriod)}</DateLabel>
        <BarContainer>
          <Bar
            onMouseOver={() => onHover([0, 0])}
            onMouseOut={() => onHover(null)}
            color={CURRENT_YEAR_COLORS[0]}
            width={startLeftPercentage}
          />
          <Bar
            onMouseOver={() => onHover([0, 1])}
            onMouseOut={() => onHover(null)}
            color={CURRENT_YEAR_COLORS[1]}
            width={startRightPercentage}
          />
        </BarContainer>
      </Row>
      <HeaderRow>
        <PercentLabel>{endLeftPercentage}</PercentLabel>
        <PercentLabel>{endRightPercentage}</PercentLabel>
      </HeaderRow>
      <Row>
        <DateLabel>{getPeriiodString(endPeriod)}</DateLabel>
        <BarContainer>
          <Bar
            onMouseOver={() => onHover([1, 0])}
            onMouseOut={() => onHover(null)}
            color={PREVIOUS_YEAR_COLORS[0]}
            width={endLeftPercentage}
          />
          <Bar
            onMouseOver={() => onHover([1, 1])}
            onMouseOut={() => onHover(null)}
            color={PREVIOUS_YEAR_COLORS[1]}
            width={endRightPercentage}
          />
        </BarContainer>
      </Row>
    </Container>
  );
};
